import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonProjectRunbookOverview, CommonProjectRunbookTopics } from "../../CommonComponents/CommonProjectRunbooksViews";

export const ProjectRunbooksRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().operations.root,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectRunbookOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectRunbookTopics />;
    },
};
